// extracted by mini-css-extract-plugin
export default {"repoLinkContainer":"RepoLink_repoLinkContainer__9Sljo","pathChar":"RepoLink_pathChar__MMjyY"};